<template>
	<div class="yh_detail_bd">
		<p class="crumbs">
			<span>您的位置 : 
      <router-link to="/Index">首页</router-link> > 
      <span @click="$router.back(-1)" class="pointer">社科成果库</span> >
			<a>正文</a>
			</span>
    </p>
    <div class="details_main_box">
      <p class="fond txt_right pointer" @click="collect_fn()" :class="{collect_color:artical.if_collect}">
        <i class="yh-heart"></i>收藏
      </p>
      <section class="book_msg">
        <div class="left img_box">
					<img src="http://localhost:8080/static/img/book/1.png" alt="">
				</div>
				<div class="left book_msg_center">
					<h5 class="artical_name">{{artical.name}}</h5>
					<p class="artical_author">作者 ：{{artical.author}}</p>
					<p class="artical_reference">推荐单位 ：{{artical.recommend_organization}}</p>
					<p class="artical_press">出版单位 ：{{artical.publish_house}}</p>
					<p class="artical_publish_time">出版时间 ：{{artical.publish_time}}</p>
					<p class="artical_Reading_volume">阅读 : {{artical.visits}}</p>
				</div>
        <div class="right">
          <el-button type="primary" size="small" style="width: 100px;margin-top:98px" @click="to_read_fn(0)">阅读</el-button>
        </div>
      </section>
      <h4 class="artical_tit_h">
        图书简介
      </h4>
			<section class="artical_intro">
				{{artical.brief}}
				本书是一部专门论述中国曲艺(相声、评书、快书、快板、鼓曲、评弹)艺术的学术专著。 全书共计11章。其中，前五章为总体论，比较全面地论述了作者对曲艺艺术的类别、源流、价值、风格以及语言等方面的整体认识；后六章为分体论，分门别类地对六大曲艺艺术—相声、评书、快书、快板、鼓曲、评弹—的艺术源流、代表人物、艺术手段和表演特色等具体特点。值得一提的是，作者所有的论述都与舞台演出的实践紧密地联系起来，从而把脚本创作与艺术表演的二度创作有机地结合在了一起，使得曲艺成为了一种“主体的活的艺术”，而这恰恰是单纯的演员经验总结或者经院式研究所不具备的。
			</section>
			<h4 class="artical_tit_h">
        	章节目录
      </h4>
			<section class="artical_catalog">
				<p v-for=" x in (artical.catalogue)">
					<span class="pointer" @click="to_read_fn">
            {{x}}
          </span>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default { 
  data () {
    return {
				artical: {
					if_collect: false,
				},
    } 
  },
  methods: {
  	collect_fn(id) {
  				this.artical.if_collect = !this.artical.if_collect;
  				var obj = {
  					if_collect: this.artical.if_collect,
  					id: this.artical.id
  				}
//  		  this.$api.axios_collect(obj).then(res => {
//    	      this.artical = res.data;  
// 				})
  	},
    to_read_fn() {
				this.$router.push({
					path: '/readOnLine',
					query: {
						id: this.artical.id
					}
				});
			}
		},
		mounted() {
				this.artical = require("../../static/json/detail.json");
			 this.$api.axios_details(this.$route.query.id).then(res => {
			      this.artical = res.data;  
			  })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../assets/css/details");
</style>



// WEBPACK FOOTER //
// src/components/details.vue